/**
 * Contact Form API Client for cPanel PHP backend
 */

export interface ContactFormData {
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  message: string;
  privacy: boolean;
}

export interface ContactFormResponse {
  success: boolean;
  message: string;
}

class ContactApiClient {
  private baseUrl: string;

  constructor() {
    // In production, this will be your domain
    // In development, you might need to adjust this
    this.baseUrl = import.meta.env.VITE_API_URL || window.location.origin;
  }

  async submitContactForm(formData: ContactFormData): Promise<ContactFormResponse> {
    const endpoint = `${this.baseUrl}/email/contact-form-handler.php`;

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || 'Failed to submit contact form');
      }

      return result;
    } catch (error) {
      console.error('Contact form submission failed:', error);
      throw error;
    }
  }
}

// Export singleton instance
export const contactApi = new ContactApiClient();
export default contactApi;
